import { render, staticRenderFns } from "./Cellar.vue?vue&type=template&id=25bd2f66"
import script from "./Cellar.vue?vue&type=script&lang=js"
export * from "./Cellar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25bd2f66')) {
      api.createRecord('25bd2f66', component.options)
    } else {
      api.reload('25bd2f66', component.options)
    }
    module.hot.accept("./Cellar.vue?vue&type=template&id=25bd2f66", function () {
      api.rerender('25bd2f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Cellar.vue"
export default component.exports